(function () {
  "use strict";

  if (!document.body.classList.contains("template-b2b-product")) return;

  var bar = document.querySelector("[data-pdp-sticky-bar]");
  if (!bar) return;

  var triggerSectionId = bar.dataset.pdpStickyTriggerSection || "pdp_compare";
  var triggerSection = document.getElementById(
    "shopify-section-" + triggerSectionId
  );

  if (!triggerSection) {
    var compare = document.querySelector(".b2b-pdp-compare");
    triggerSection = compare ? compare.closest(".shopify-section") : null;
  }

  if (!triggerSection) return;

  var triggerEnd =
    triggerSection.querySelector("[data-pdp-sticky-trigger-end]") ||
    triggerSection;

  var isActive = false;
  var latched = false;

  function setVisible(visible) {
    if (visible === isActive) return;
    isActive = visible;
    bar.classList.toggle("is-visible", visible);
    bar.setAttribute("aria-hidden", visible ? "false" : "true");
    document.body.classList.toggle("pdp-sticky-bar-active", visible);
  }

  function update() {
    var rect = triggerEnd.getBoundingClientRect();

    /* Compare end still below the viewport */
    if (rect.top > window.innerHeight) {
      latched = false;
      setVisible(false);
      return;
    }

    /* Scrolled to the end of the compare section */
    latched = true;
    setVisible(true);
  }

  update();

  window.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", update, { passive: true });

  if ("IntersectionObserver" in window) {
    var observer = new IntersectionObserver(
      function () {
        update();
      },
      { threshold: [0, 0.01, 0.1, 0.5, 1] }
    );
    observer.observe(triggerSection);
  }
})();
